const TestIds = {
    Global: {
        PageLoading: 'global-page-loading',
        RawLoader: 'global-raw-loader',
        Header: 'global-header',
    },
    Sidebar: {
        LinksContainer: 'sidebar-links-container',
        HomeLink: 'sidebar-home-link',
        CampaignsLink: 'sidebar-campaigns-link',
        TransactionsLink: 'sidebar-transactions-link',
        ContactsLink: 'sidebar-contacts-link',
        EngageLink: 'sidebar-engage-link',
        SettingsLink: 'sidebar-settings-link',
        PayoutsLink: 'payouts-link',
        NewCampaignsButton: 'sidebar-new-campaigns-button',
    },
    Campaigns: {
        DialogClose: 'campaigns-dialog-close',
    },
    DevLogin: {
        Email: 'dev-login-email',
        Password: 'dev-login-password',
        Submit: 'dev-login-submit',
    },
    Transactions: {
        Home: 'transactions-home',
        Tickets: 'transactions-tickets',
        Plans: 'transactions-plans',
        Pledges: 'transactions-pledges',
    },
    Contacts: {
        Home: 'contacts-home',
        Duplicates: 'contacts-duplicates',
        DataHygiene: 'contacts-data-hygiene',
    },
    Engage: {
        Emails: 'engage-emails',
        Texts: 'engage-texts',
        Mailings: 'engage-mailings',
        Settings: {
            EmailDomains: 'engage-settings-email-domains',
            EngageSenders: 'engage-settings-email-senders',
            SmsNumbers: 'engage-settings-sms-numbers',
            SmsKeywords: 'engage-settings-sms-keywords',
            Branding: 'engage-settings-branding',
            Addresses: 'engage-settings-addresses',
            MergeFields: 'engage-settings-merge-fields',
        },
    },
    Payouts: {
        All: 'payouts-all',
        HasBalance: 'payouts-has-balance',
        Withdrawn: 'payouts-withdrawn',
        History: 'payouts-history',
        TaxDocuments: 'payouts-tax-documents',
        PayoutSettings: 'payouts-settings',
    },
    AccountSettings: {
        About: {
            Profile: 'account-settings-about-profile',
            Addresses: 'account-settings-about-addresses',
            Branding: 'account-settings-about-branding',
            LandingPage: 'account-settings-about-landing-page',
            Verification: 'account-settings-about-verification',
            Billing: 'account-settings-about-billing',
        },
        Account: {
            General: 'account-settings-account-general',
            TextToDonate: 'account-settings-account-text-to-donate',
            ThankYouMessage: 'account-settings-account-thank-you-message',
            EoySummaries: 'account-settings-account-eoy-summaries',
            TaxDeductibility: 'account-settings-account-tax-deductibility',
            Appeals: 'account-settings-account-appeals',
            Funds: 'account-settings-account-funds',
            Notifications: 'account-settings-account-notifications',
        },
        Integrations: {
            ThirdParty: 'account-settings-integrations-third-party',
            Zapier: 'account-settings-integrations-zapier',
            QuickBooks: 'account-settings-integrations-quickbooks',
            Webhooks: 'account-settings-integrations-webhooks',
            Widgets: 'account-settings-integrations-widgets',
            Api: 'account-settings-integrations-api',
        },
        Users: 'account-settings-users',
        Imports: {
            History: 'account-settings-imports-history',
            Drafts: 'account-settings-imports-drafts',
            RecurringPlans: 'account-settings-imports-recurring-plans',
        },
    },
};

export { TestIds };
